angular.module('picmonicng').component('ltiSubmissionDetailComponent', {
  templateUrl: '/templates/app/pages/lti-submission-detail/lti-submission-detail.html',
  bindings: {},
  controller: [
    '$stateParams',
    'User',
    function ($stateParams, User) {
      $ctrl = this;
      $ctrl.Math = window.Math;
      $ctrl.round = User.getv3({
        resource: 'quizround',
        resource_id: $stateParams.id,
      });
      $ctrl.round.$promise.then(function () {
        $ctrl.time = $ctrl.round.answers[$ctrl.round.answers.length - 1].end_time - $ctrl.round.answers[0].start_time;
      });
    },
  ],
});
